<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @updateSpaceSize="getCntList"></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="4" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="4" :currentTab2="0" />
            <div class="tab-content">
             
              <div>
                <div class="tb-list_ty1 audit001">
                  <div class="tb-header clear">
                    <SelectBox
                        v-model="selectedTenantId"
                        valueProp = "tenantId"
                        textProp = "tenantName"
                        :disabled="view.disabled"
                        :excludes="view.selectExcludes"
                        div-cls="selectDiv"
                        :dtl-cd-list="codes.selectList">
                    </SelectBox>
                    <div class="btnDiv fr">
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="TotalView()"
                        v-if="!isTotalView"
                      >전체
                      </button>
                        <button
                        type="button"
                        class="btn-primary-small"
                        @click="getStatistiscExcelDownload('TOTAL')"
                         v-if="!isTotalView"
                      >다운로드
                      </button>
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="TermView()"
                        v-if="isTotalView"
                      >기간별 검색
                      </button>
                    </div>
                    <div class="search_ty2 fr"  v-if="!isTotalView">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                  <!-- //tb-header -->

                  <v-data-table
                    :headers="headers"
                    :items="selDates"
                    :disable-pagination="true"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <!-- {{setCurrentSelDate(item)}} -->
                      <tr>
                        <td>
                          <div>
                            <span> {{ item }} </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              class="ell-singleline d-block cursor-pointer"
                              @click="getStatistiscExcelDownload('USER', item)"
                              v-if="item != '전체'"
                            >
                                 {{getCount('USER', item)}}
                            </span>
                            <span v-else>
                                 {{getCount('USER', item)}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              class="ell-singleline d-block cursor-pointer"
                              @click="getStatistiscExcelDownload('COGROUP', item)"
                              v-if="item != '전체'"
                            >
                               {{getCount('COGROUP', item)}}
                            </span>
                            <span v-else>
                                 {{getCount('COGROUP', item)}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span  
                              class="ell-singleline d-block cursor-pointer"
                              @click="getStatistiscExcelDownload('COPAPER', item)"
                              v-if="item != '전체'"
                            > 
                              {{getCount('COPAPER', item)}} 
                            </span>
                            <span v-else>
                                 {{getCount('COPAPER', item)}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span  
                              class="ell-singleline d-block cursor-pointer"
                              @click="getStatistiscExcelDownload('PRIVATEPAPER', item)"
                              v-if="item != '전체'"
                            > 
                              {{getCount('PRIVATEPAPER', item)}} 
                            </span>
                            <span v-else>
                                 {{getCount('PRIVATEPAPER', item)}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span  
                              class="ell-singleline d-block cursor-pointer"
                              @click="getStatistiscExcelDownload('TODO', item)"
                              v-if="item != '전체'"
                            > 
                              {{getCount('TODO', item)}} 
                            </span>
                            <span v-else>
                                 {{getCount('TODO', item)}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                             <span  
                              class="ell-singleline d-block cursor-pointer"
                              @click="getStatistiscExcelDownload('DECISION', item)"
                              v-if="item != '전체'"
                            > 
                              {{getCount('DECISION', item)}} 
                            </span>
                             <span v-else>
                                 {{getCount('DECISION', item)}}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          데이터가 없습니다.
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <!-- <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getGroupList"
                    ></v-pagination>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import SelectBox from "./common/SelectBox";
export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
    SelectBox,
  },
  data() {
    return {
      // form : {
        // select : '202'
      // },
      selectedTenantId : "",
      //ui 관련
      view : {
          selectExcludes : [],
          
          disabled : false
      },
      //공통코드 목록. request attribute 로 가져오거나 ajax 로 가져오거나..
      codes : {
          selectList : []
      },
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      // page: 1,
      // pageCount: 1,
      // totalCount: 0,
      // itemsPerPage: 100,
      singleSelect: false,
      // selected: [],
      currentSelDate : "",
      headers: [
        { text: "날짜", value: "selDate", align: "center", sortable: false  },
        { text: "사용자", value: "userCnt", align: "center", sortable: false },
        { text: "협업공간", value: "coGroupCnt", sortable: false },
        { text: "협업보드", value: "coPaperCnt", sortable: false },
        { text: "프라이빗보드", value: "privateBoardCnt", sortable: false },
        { text: "Task", value: "taskCnt", sortable: false },
        { text: "의사결정", value: "decisionCnt", sortable: false }
      ],
      selDates: [],
      userCountMap : [],
      coPaperCountMap : [],
      privatePaperCountMap : [],
      todoCountMap : [],
      decisionCountMap : [],
      cogroupCountMap : [],
      isTotalView : false,
      // searchGroupName: "",
      startDate: new Date(this.$moment().subtract(1, "months")),
      endDate: new Date(this.$moment()),
      startDisabledDate: {
        from: new Date(this.$moment()), // 이후 선택 기간 제한
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(1, "months")), //이전 선택 기간 제한
      },
    };
  },
  created() {
    this.getTenantList();
  },
  watch: {
    startDate() {
      if(this.$moment(this.endDate).diff(this.startDate, 'months') > 1){
        this.showAlertDialog("조회 기간은 2개월 이내로 해주세요");
        // alert("조회 기간은 2개월 미만으로 해주세요");
        
      }else{
        this.setDisabledDate();
        this.getCntList();
      }
      
    },
    endDate() {
      if(this.$moment(this.endDate).diff(this.startDate, 'months') > 1){
        // alert("조회 기간은 2개월 미만으로 해주세요");
        this.showAlertDialog("조회 기간은 2개월 이내로 해주세요");
      }else{
        this.setDisabledDate();
        this.getCntList();
      }
    },
     'selectedTenantId' : function() {
        // console.log('select changed, value = ' + this.selectedTenantId);
        this.getCntList();
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),
    getTenantList(){
     
      let obj = this;
      let reqData = {};

      reqData.params = {};
      
      reqData.url = "/api/org/statistics/getTenantList";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {

            //console.log(res.result.tenantInfoList);
          
            obj.selectedTenantId =localStorage.getItem("tenantId");
            obj.codes.selectList = res.result.tenantInfoList;

          }
 
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 카운트 조회 */
    getCntList(isTotalView) {
      let obj = this;
      let reqData = {};
      // if(isTotalView === undefined) isTotalView = false;
      reqData.params = {
        // currentPage: obj.page.toString(),
        // itemsPerPage: obj.itemsPerPage.toString(),
        startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
        endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        tenantId: obj.selectedTenantId,
        isTotalView: obj.isTotalView
        // searchGroupName: obj.searchGroupName,
      };
      
      reqData.url = "/api/org/statistics/getStatisticsCount";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {  
              obj.selDates = res.result.selDates;
              obj.userCountMap = res.result.userCountMap;
              obj.coPaperCountMap = res.result.coPaperCountMap;
              obj.privatePaperCountMap = res.result.privatePaperCountMap;
              obj.todoCountMap = res.result.todoCountMap;
              obj.decisionCountMap = res.result.decisionCountMap;
              obj.cogroupCountMap = res.result.cogroupCountMap;

          }
        
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    setDisabledDate() {
      this.startDisabledDate.from = this.endDate;
      this.endDisabledDate.to = this.startDate;
    },
    TotalView(){ //전체 버튼 눌렀을 경우 처리
      this.isTotalView = true;
      this.getCntList();
    },
    TermView(){ //기간별 검색 눌렀을 경우 처리
      this.isTotalView = false;
      this.getCntList();
    },
    setCurrentSelDate(selDate){ 
      // console.log("selDate : "+ selDate);
      this.currentSelDate = selDate;
    },
    getCount(type, selDate){ //유형별로 통계수 가져오는 처리
      let returnCnt = 0;
      if(type === 'USER'){
        returnCnt = this.userCountMap[selDate];
      }else  if(type === 'COGROUP'){
        returnCnt = this.cogroupCountMap[selDate];
      }else  if(type === 'COPAPER'){
        returnCnt = this.coPaperCountMap[selDate];
      }else  if(type === 'PRIVATEPAPER'){
        returnCnt = this.privatePaperCountMap[selDate];
      }else  if(type === 'TODO'){
        returnCnt = this.todoCountMap[selDate];
      }else  if(type === 'DECISION'){
        returnCnt = this.decisionCountMap[selDate];
      }
      
      if(returnCnt === undefined) returnCnt = 0;
   //   console.log("returnCnt : "+ returnCnt);
      return returnCnt;
    },
    getStatistiscExcelDownload(type, selDate) {/*  유형별 엑셀 다운로드 */
        let obj = this;
        
        //계 부분을 누를경우 selDate를 null로 넘겨서 서버단에서 startDate와 endDate로 처리하도록 변경
        if(selDate === '계') { selDate = null;}
        // console.log("type : "+ type + " > selDate : "+ selDate);
        
        let reqData = {};
        reqData.params = {
            type: type,
            selectedDate: selDate,
            tenantId: obj.selectedTenantId,
            startDate: obj.$moment(this.startDate).format("YYYY.MM.DD"),
            endDate: obj.$moment(this.endDate).format("YYYY.MM.DD"),
        };

        //프로그레스바 시작
        this.showLoadingbar();
        obj.$axios({
            url: "/api/org/statistics/getStatistiscExcelDownload",
            responseType: "blob",
            headers: {
                "Content-Type": "application/json"
            },
            method: "post",
            data: reqData.params
        }).then(res => {
            let fileName = null;
            if("TOTAL" === type){ fileName = "통계 목록"; }
            else if("USER" === type){ fileName = "사용자 목록" ;  }
            else if("COGROUP" === type){ fileName = "협업공간 목록";   }
            else  if("COPAPER" === type){  fileName = "협업보드 목록" ;  }
            else  if("PRIVATEPAPER" === type){  fileName = "프라이빗보드 목록";  }
            else  if("TODO" === type){   fileName = "TASK 목록" ; }
            else  if("DECISION" === type){ fileName = "의사결정 목록";   }

            if(type === "TOTAL" || selDate === null){
              fileName += "("+obj.$moment(this.startDate).format("YYYY.MM.DD")+"~"+obj.$moment(this.endDate).format("YYYY.MM.DD")+")" ;
            }else{
              fileName += " ("+selDate+")";
            }

            let blob = new Blob([res.data], {
                type: res.headers["content-type"]
            });

            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName+".xlsx");
            } else {
                let link = document.createElement("a");
                link.target = "_self";
                link.setAttribute("download", fileName+".xlsx");
                link.href = window.URL.createObjectURL(blob);
                link.click();
                link.remove();
            }
            this.hideLoadingbar();
        })
        .catch(err => {
            //프로그레스바 종료 
            this.hideLoadingbar();
            console.log("axios err => ", err);
        });
    },
    
  }
};
</script>

<style scoped>
.audit001 {
  margin-top: 38px;
}
.audit001 >>> td:nth-child(1) > div > .ell-singleline {
  width: 110px;
}
.audit001 >>> th:nth-child(1),
.audit001 >>> td:nth-child(1) {
  padding-left: 25px;
  width: calc(100% - 3500px) !important;
  text-align: center;
}
.audit001 >>> th:nth-child(2),
.audit001 >>> td:nth-child(2) {
  width: 150px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(3),
.audit001 >>> td:nth-child(3) {
  width: 150px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(4),
.audit001 >>> td:nth-child(4) {
  width: 150px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(5),
.audit001 >>> td:nth-child(5) {
  width: 150px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(6),
.audit001 >>> td:nth-child(6) {
  width: 150px !important;
  text-align: center;
}

.audit001 >>> th:nth-child(7),
.audit001 >>> td:nth-child(7) {
  width: 150px !important;
  text-align: center;
}

.audit001 >>> th.text-center {
  text-align: center;
}
.audit001 >>> input {
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/StatisticsManage.vue